// extracted by mini-css-extract-plugin
export var quillEditor = "_p3-1";
export var variable = "_p3-0";